import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// import type { PayloadAction } from '@reduxjs/toolkit'

export interface UserState {
    id: number,
    refetch: boolean,
    isLogin: boolean,
}

const initialState: UserState = {
    id: 0,
    refetch: false,
    isLogin: false,
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setId(state, action: PayloadAction<number>) {
            state.id = action.payload;
        },
        setRefetch(state, action: PayloadAction<boolean>) {
            state.refetch = action.payload;
        },
        setIsLogin(state, action: PayloadAction<boolean>) {
            state.isLogin = action.payload;
        },

    },
})

// Action creators are generated for each case reducer function
export const { setId, setRefetch, setIsLogin } = userSlice.actions

export default userSlice.reducer